import React from 'react';
import FilterBySixMonths from './Components/FilterBySixMonths';
import {useFormikContext} from 'formik';
import FilterByStatus from './Components/FilterByStatus';
import {useTranslation} from 'react-i18next';
import {LogisticListRequestType} from '../../types/TypesDepotLogistic';
import LightGreenButton from '../Buttons/LightGreenButton';
import GreenButton from '../Buttons/GreenButton';

type Props = {
	active: boolean;
	setFilters: any;
};
const CustomerOrdersFilter: React.FC<Props> = ({active, setFilters}) => {
	const {t} = useTranslation();
	const {values, setFieldValue, resetForm} =
		useFormikContext<LogisticListRequestType>();
	const statusPayOptions = [
		{label: t('Оплачено'), value: '1'},
		{label: t('Неоплачено'), value: '0'},
	];
	const deliveryTypeOptions = [
		{label: t('Нова пошта'), value: 'post'},
		{label: t('Самовивіз'), value: 'self-delivery'},
	];
	const paymentTypeOptions = [
		{label: t('Картка'), value: 'card'},
		{label: t('Готівка'), value: 'afterpay'},
	];
	const statusDeliveryOptions = [
		{label: t('Доставлено'), value: 'shipped'},
		{label: t('Не доставлено'), value: 'confirmed'},
	];
	return (
		<div
			className={`filter-team__filter-item item-filter ${!active ? '' : 'active'}`}
		>
			<div className="item-filter__wrapper">
				<FilterBySixMonths setFieldValue={setFieldValue} />
				<FilterByStatus
					statusOptions={statusPayOptions}
					label={t('Статус оплати')}
					value={values.status_pay ?? ''}
					fieldName={'status_pay'}
				/>
				<FilterByStatus
					statusOptions={deliveryTypeOptions}
					label={t('Спосіб доставки')}
					value={values.delivery_type ?? ''}
					fieldName={'delivery_type'}
				/>
				<FilterByStatus
					statusOptions={paymentTypeOptions}
					label={t('Спосіб оплати')}
					value={values.payment_method ?? ''}
					fieldName={'payment_method'}
				/>
				<FilterByStatus
					statusOptions={statusDeliveryOptions}
					label={t('Статус доставки')}
					value={values.status_delivery ?? ''}
					fieldName={'status_delivery'}
				/>
				{/*<div className="form-filter__item form-filter__item-checkbox">
					<div className={s.filterStatusContainer}>
						<div>Статус доставки</div>
						<div
							role={'button'}
							tabIndex={0}
							onClick={() => setDeliveryStatus(!deliveryStatus)}
						>
							<img
								style={{transform: deliveryStatus ? 'rotate(180deg' : ''}}
								src={arrow}
								alt="arrow"
							/>
						</div>
					</div>
					{deliveryStatus && (
						<div className={s.checkBoxContainer}>
							<div className="checkbox">
								<label htmlFor="showOnlyManager" className="checkbox__label">
									Доставлено
								</label>
								<input
									id="showOnlyManager"
									type="checkbox"
									name="onlyManager"
									className="checkbox__input"
								/>
							</div>
							<div className="checkbox">
								<label htmlFor="showOnlyClient" className="checkbox__label">
									Не доставлено
								</label>
								<input
									id="showOnlyClient"
									type="checkbox"
									name="onlyClient"
									className="checkbox__input"
								/>
							</div>
						</div>
					)}
				</div>*/}
				<div className="item-filter__buttons">
					<LightGreenButton text={t('застосувати')} type={'submit'} />
					<GreenButton
						text={t('скасувати фільтр')}
						type={'button'}
						onClick={() => {
							resetForm();
							setFilters && setFilters({filter_active: false, offset: 0});
						}}
					/>
				</div>
			</div>
		</div>
	);
};

export default CustomerOrdersFilter;
